import Checkbox from './Checkbox.jsx';

export default Checkbox;
